import { Epic, ofType } from 'redux-observable';
import { concat, EMPTY, from, Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { Action } from '../../actions';
import {
    SaveImportExportWizardSuccess,
    saveImportExportWizardSuccessAction
} from '../../actions/importExportWizard/saveImportExportWizardSuccess';
import {
    ShowUploadFileImportWizardRequestError,
    showUploadFileImportWizardRequestErrorAction
} from '../../actions/importWizard/showUploadFileImportWizardRequestError';
import {
    UpdateImportWizardData,
    updateImportWizardDataAction
} from '../../actions/importWizard/updateImportWizardData';
import {
    UpdateImportWizardStep,
    updateImportWizardStepAction
} from '../../actions/importWizard/updateImportWizardStep';
import { UPLOAD_FILE_IMPORT_WIZARD, UploadFileImportWizard } from '../../actions/importWizard/uploadFileImportWizard';
import { ApiMethodExecutingError } from '../../service/Errors';
import { captureException } from '../../service/ErrorsReporting/ErrorsReporting';
import { EpicDeps } from '../../service/StoreFactory';
import { ImportWizardPhase } from '../../typings/importWizard';
import { State } from '../../typings/state';

type EpicActions =
    | UpdateImportWizardData
    | SaveImportExportWizardSuccess
    | UpdateImportWizardStep
    | ShowUploadFileImportWizardRequestError;

export const uploadFileImportWizardEpic: Epic<Action, Action, State, EpicDeps> = (action$, store, deps) => {
    return action$.pipe(
        ofType(UPLOAD_FILE_IMPORT_WIZARD),
        switchMap(
            (action: UploadFileImportWizard): Observable<EpicActions> => {
                const state = store.value;
                const { login } = state.commonData;
                const { importMode, importFile } = state.importWizard;
                const file = importFile && importFile.file;

                if (!file) {
                    return EMPTY;
                }

                return from(deps.importProvider.uploadFile(login, file, importMode)).pipe(
                    switchMap(
                        (data): Observable<EpicActions> =>
                            concat(
                                of(updateImportWizardDataAction(data)),
                                of(updateImportWizardStepAction(ImportWizardPhase.IMAGE_UPLOAD)),
                                of(saveImportExportWizardSuccessAction())
                            )
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError | Error
                        ): Observable<ShowUploadFileImportWizardRequestError> => {
                            captureException(
                                error instanceof ApiMethodExecutingError ? error.getNativeError() : error,
                                {
                                    extra: {
                                        action: UPLOAD_FILE_IMPORT_WIZARD
                                    }
                                }
                            );

                            if (error instanceof ApiMethodExecutingError) {
                                return of(showUploadFileImportWizardRequestErrorAction(error));
                            }

                            return of(showUploadFileImportWizardRequestErrorAction());
                        }
                    )
                );
            }
        )
    );
};
